import RequestTenderPopover from './RequestTenderPopover';

export default RequestTenderPopover;
